import { CsiteSupplier } from '@arpada/arp-lib-common-qupro';

export class ActionsSharedData {
    public totalCount: string;
    public idsSelected: string;
    public issuesFrontIdsSelected: number[] = [];
    public issuesIdsEditadasMasivamente: number[] = [];
    public csites: CsiteSupplier[] = [];
    public loadingComboCsites: boolean;
}
